import { render, staticRenderFns } from "./ArtWorks.vue?vue&type=template&id=d2a86542&scoped=true"
import script from "./ArtWorks.vue?vue&type=script&lang=js"
export * from "./ArtWorks.vue?vue&type=script&lang=js"
import style0 from "./ArtWorks.vue?vue&type=style&index=0&id=d2a86542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a86542",
  null
  
)

export default component.exports